export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10293.bc5ed1d4.jpg";